import React, { useEffect } from "react";

export const CaseDetail = (props) => {
  const { data, onBack, allCases, onOpenCase } = props;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [data && data.slug]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onBack && onBack();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onBack]);

  if (!data) return null;

  const otherCases = (allCases || []).filter((c) => c.slug !== data.slug);

  return (
    <div className={`case-detail ribbon-${data.ribbon || "indigo"}`}>
      <div className="case-detail-ribbon" />

      <div className="case-detail-topbar">
        <a
          href="#page-top"
          className="case-detail-brand"
          onClick={(e) => {
            e.preventDefault();
            onBack && onBack();
          }}
          aria-label="GOLDLY AI home"
        >
          <img
            src="img/logo/logo-trim.png"
            alt="GOLDLY AI"
            className="case-detail-logo"
          />
        </a>
        <button
          type="button"
          className="case-detail-back"
          onClick={onBack}
        >
          <i className="fa fa-arrow-left" /> Back to Cases
        </button>
      </div>

      {data.heroImage && (
        <div className="case-detail-hero">
          <img
            src={data.heroImage}
            alt={`${data.name} cover`}
            className="case-detail-hero-img"
          />
        </div>
      )}

      <div className="case-detail-container">
        <header className="case-detail-header">
          <div
            className={`case-monogram case-monogram-lg${
              data.logo ? " has-logo" : ""
            }`}
            aria-hidden="true"
          >
            {data.logo ? (
              <img
                src={data.logo}
                alt={`${data.name} logo`}
                className="case-monogram-img"
              />
            ) : (
              data.code
            )}
          </div>
          <div className="case-detail-header-text">
            <div className="case-detail-industry">
              <i className={data.icon || "fa fa-briefcase"} /> {data.industry}
              {data.date && (
                <span className="case-detail-date">· {data.date}</span>
              )}
            </div>
            <h1 className="case-detail-title">{data.name}</h1>
            <p className="case-detail-summary">{data.summary}</p>
          </div>
        </header>

        {Array.isArray(data.products) && data.products.length > 0 && (
          <div className="case-detail-products">
            <span className="case-detail-products-label">
              Products & Solutions
            </span>
            {data.products.map((p, i) => (
              <span key={i} className="case-chip">
                {p}
              </span>
            ))}
          </div>
        )}

        <div className="case-detail-body">
          {Array.isArray(data.details) &&
            data.details.map((para, i) => {
              const inline =
                data.inlineImages && data.inlineImages[i];
              return (
                <React.Fragment key={i}>
                  <p className="case-detail-paragraph">{para}</p>
                  {inline && (
                    <figure className="case-detail-figure">
                      <img src={inline.src} alt={inline.caption || ""} />
                      {inline.caption && (
                        <figcaption>{inline.caption}</figcaption>
                      )}
                    </figure>
                  )}
                </React.Fragment>
              );
            })}
        </div>

        {otherCases.length > 0 && (
          <div className="case-detail-related">
            <h3 className="case-detail-related-title">More Customer Cases</h3>
            <div className="case-detail-related-grid">
              {otherCases.map((c) => (
                <button
                  key={c.slug}
                  type="button"
                  className={`case-related-card ribbon-${c.ribbon || "indigo"}`}
                  onClick={() => onOpenCase && onOpenCase(c.slug)}
                >
                  <div className="case-ribbon" />
                  <div className="case-related-row">
                    <div
                      className={`case-monogram${c.logo ? " has-logo" : ""}`}
                      aria-hidden="true"
                    >
                      {c.logo ? (
                        <img
                          src={c.logo}
                          alt={`${c.name} logo`}
                          className="case-monogram-img"
                        />
                      ) : (
                        c.code
                      )}
                    </div>
                    <div>
                      <div className="case-name">{c.name}</div>
                      <div className="case-industry">{c.industry}</div>
                    </div>
                  </div>
                  <span className="case-readmore">
                    Read case <i className="fa fa-arrow-right" />
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
